/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const createProjectPrioritySchema = z.object({
  name: z.coerce.string(),
});
